require("./Checklist.less");

const React = require("react");

const Comment = require("../Comment/Comment.jsx");
const Task = require("../Task/Task.jsx"); 
const QuestionType = require("~/types/Question.js").PropType;
const NewAnswerSelection = require("~/types/AnswerSelection.js").New;

const Checklist = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
        OnAnswerChange: React.PropTypes.func.isRequired
    },
    getInitialState() {
        this.BindIsSelectionAvailable();

        const asAnswerSelection = ((sel) => NewAnswerSelection(
            sel.SelectionText,
            sel.AdditionalComment,
            sel.GUID,
            sel.SelectionScoreValue));

        const selections = this.props.Question.AnswerSelections
            .filter(this.IsSelectionAvailable) // Ignore selections that aren't actually on the list
            .map(asAnswerSelection);

        return {
            AnswerSelections: selections,
            AdditionalComment: this.props.Question.AdditionalComment,
            Task: this.props.Question.Task
        };
    },
    
    render() {
        const checklist = this.props.Question.AnswerOptions.map(this.MakeItem);

        const showCommentField = this.props.Question.IncludeComment;

        return (<div className="cs-Checklist">
            <header className="cs-Checklist__question"
                    dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></header>
            <ul className="cs-Checklist__list">
                {checklist}
            </ul>
            {showCommentField && (
            <Comment OnChange={this.OnCommentChange} Comment={this.state.AdditionalComment} />)}
            <Task OnChange={this.OnTaskChange} Task={this.state.Task}></Task>
        </div>);
    },
    AnswerChanged(e) {
        let newAnswers = this.state.AnswerSelections.slice();

        if (e.target.checked) {
            newAnswers.push(NewAnswerSelection(e.target.value))
        }
        else {
            newAnswers = newAnswers.filter((sel) => sel.SelectionText !== e.target.value);
        }

        this.props.OnAnswerChange(newAnswers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: newAnswers
        });
    },
    MakeItem(answerOption) {
        const checked = this.IsSelected(answerOption.DisplayText);

        return (<li key={answerOption.GUID }>
            <label className="cs-Checklist__list-item__label">
                <input type="checkbox" className="cs-Checklist__checkbox"
                       checked={checked} value={answerOption.DisplayText}
                       onChange={this.AnswerChanged} />
                {answerOption.DisplayText}
            </label>
        </li>);
    },
    BindIsSelectionAvailable() {
        const availableValues = this.props.Question.AnswerOptions.map((opt) => opt.DisplayText);

        this.IsSelectionAvailable = (sel) => availableValues.find((available) => available === sel.SelectionText);
    },
    IsSelectionAvailable(sel) {
        throw "Not implemented (this should have been bound dynamically)";
    },
    IsSelected(text) {
        if (this.state.AnswerSelections
                .map((sel) => sel.SelectionText)
                .find((val) => val === text)) {
            return true;
        }

        return false;
    },
    OnCommentChange(e) {
        this.props.OnAnswerChange(this.state.AnswerSelections, e.target.value, this.state.Task);

        this.setState({
            AdditionalComment: e.target.value
        });
    },
    OnTaskChange(e) {
        this.props.OnAnswerChange(this.state.AnswerSelections, this.state.AdditionalComment, e.target.value);

        this.setState({
            Task: e.target.value
        })
    }
});

module.exports = Checklist;


// WEBPACK FOOTER //
// ./src/components/Checklist/Checklist.jsx